import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { PermissionsService } from '@app/core/services/permissions.service';
import { NGXLogger } from 'ngx-logger';

@Directive({
  selector: '[appCanAccess]'
})
export class CanAccessDirective implements OnInit, OnDestroy {

  @Input() set appCanAccess(value: string | string[]) {
    this.applyPermission(value);
  }
  private permission$: Subscription;

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private workflowEvents: PermissionsService,
              private logger:NGXLogger ) {
  }

  ngOnInit(): void {
  }

  private applyPermission(value: string | string[]): void {
    this.permission$ = this.workflowEvents.checkAuthorization(value)
      .subscribe(authorized => {
        // this.logger.debug('value', value);
        // this.logger.debug('authorized', authorized);
        if (authorized) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
  }

  ngOnDestroy(): void {
    this.permission$.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/directives/can-access.directive.ts